import { Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-data-not-found',
  imports: [CommonModule],
  templateUrl: './data-not-found.html',
  styleUrl: './data-not-found.scss'
})
export class DataNotFound {
  message = input<string>('No data found');
  subMessage = input<string>('It seems there is no information available at the moment.');
}
